import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/no-unescaped-entities */
import classnames from "classnames";
import React, { useEffect, useMemo } from "react";
import { useResumeData } from "../../hooks";
import { Loading } from "../loading";
import { Certifications } from "./certifications";
import { ContactInfo } from "./contact-info";
import { Education } from "./education";
import { Highlights } from "./highlights";
import { Intro } from "./intro";
import styles from "./resume.module.less";
import { Skills } from "./skills";
import { WorkExperience } from "./work-experience";
export var Resume = function Resume(_ref) {
  var _ref2;

  var _ref$embedded = _ref.embedded,
      embedded = _ref$embedded === void 0 ? false : _ref$embedded,
      id = _ref.id,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? "view" : _ref$mode,
      noResume = _ref.noResume,
      onEditSection = _ref.onEditSection,
      resumeData = _ref.resumeData;
  var isEditMode = mode === "edit"; // skip loading if we've provided `resumeData` through a prop

  var _useResumeData = useResumeData(resumeData ? undefined : id, isEditMode ? "edit" : "view"),
      resumeIsLoaded = _useResumeData.isLoaded,
      resumeIsLoading = _useResumeData.isLoading,
      error = _useResumeData.error,
      data = _useResumeData.data,
      resumeIsEmpty = _useResumeData.isEmpty;

  var resume = (_ref2 = resumeData ? resumeData : data === null || data === void 0 ? void 0 : data.resume) !== null && _ref2 !== void 0 ? _ref2 : {};
  var isLocalData = id === undefined;
  var isLoaded = isLocalData ? !!resumeData : resumeIsLoaded;
  var isLoading = isLocalData ? !resumeData : resumeIsLoading;
  var isEmpty = isLocalData ? !(resumeData !== null && resumeData !== void 0 && resumeData.contact_info) : resumeIsEmpty;
  useEffect(function () {
    if (!embedded) {
      document.body.classList.add("-presentation");
      return function () {
        document.body.classList.remove("-presentation");
      };
    }
  }, [embedded]);
  var onEditClick = useMemo(function () {
    return {
      ContactInfo: function ContactInfo() {
        return onEditSection === null || onEditSection === void 0 ? void 0 : onEditSection("contact-info");
      },
      Highlights: function Highlights() {
        return onEditSection === null || onEditSection === void 0 ? void 0 : onEditSection("highlights");
      },
      Intro: function Intro() {
        return onEditSection === null || onEditSection === void 0 ? void 0 : onEditSection("intro");
      },
      Skills: function Skills() {
        return onEditSection === null || onEditSection === void 0 ? void 0 : onEditSection("skills");
      },
      WorkExperience: function WorkExperience() {
        return onEditSection === null || onEditSection === void 0 ? void 0 : onEditSection("work-experience");
      },
      Education: function Education() {
        return onEditSection === null || onEditSection === void 0 ? void 0 : onEditSection("education");
      },
      Certifications: function Certifications() {
        return onEditSection === null || onEditSection === void 0 ? void 0 : onEditSection("certifications");
      }
    };
  }, [onEditSection]);

  if (isEmpty) {
    return /*#__PURE__*/React.createElement("section", {
      className: "info"
    }, /*#__PURE__*/React.createElement("h1", null, "No resume"), /*#__PURE__*/React.createElement("p", null, "There is no resume available to load"), noResume);
  }

  if (error) {
    return /*#__PURE__*/React.createElement("section", {
      className: "error"
    }, /*#__PURE__*/React.createElement("h1", null, "Error"), /*#__PURE__*/React.createElement("p", null, error));
  }

  if (isLoading || !isLoaded || !resume) return /*#__PURE__*/React.createElement(Loading, null);

  var props = _objectSpread({}, isEditMode && {
    "data-editable": true
  });

  return /*#__PURE__*/React.createElement("section", {
    className: classnames(styles.root, embedded && styles.embedded, "root", "resume-root", "title-focused", isEditMode && styles.editMode)
  }, /*#__PURE__*/React.createElement(ContactInfo, _extends({}, props, resume.contact_info, {
    onClick: onEditClick.ContactInfo
  })), /*#__PURE__*/React.createElement("section", {
    className: "container"
  }, /*#__PURE__*/React.createElement("aside", {
    className: "left-panel"
  }, /*#__PURE__*/React.createElement(Highlights, _extends({}, props, {
    empty: isEditMode && !resume.highlights.length,
    highlights: resume.highlights,
    onClick: onEditClick.Highlights
  })), /*#__PURE__*/React.createElement(Skills, _extends({}, props, {
    skills: resume.skills,
    empty: isEditMode && !resume.skills.length,
    "data-editable": true,
    onClick: onEditClick.Skills
  }))), /*#__PURE__*/React.createElement("main", {
    className: "main-panel"
  }, /*#__PURE__*/React.createElement(Intro, _extends({}, props, {
    empty: isEditMode && !resume.intro,
    onClick: onEditClick.Intro
  }), resume.intro), /*#__PURE__*/React.createElement(WorkExperience, _extends({}, props, {
    empty: isEditMode && !resume.work_experience.length,
    work_experience: resume.work_experience,
    onClick: onEditClick.WorkExperience
  })), /*#__PURE__*/React.createElement(Education, _extends({}, props, {
    empty: isEditMode && !resume.education.length,
    education: resume.education,
    onClick: onEditClick.Education
  })), /*#__PURE__*/React.createElement(Certifications, _extends({}, props, {
    empty: isEditMode && !resume.certifications.length,
    certifications: resume.certifications,
    onClick: onEditClick.Certifications
  })))), /*#__PURE__*/React.createElement("footer", null, /*#__PURE__*/React.createElement("h5", null, resume.contact_info.name)));
};